// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../shared/images/opened_eye.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../../shared/images/closed_eye.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
    width: 30%;
    margin: auto;
}

.login-form .login-form__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4rem;
}

.login-form .login-form__body .login-form__item {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 2rem;
}

.login-form .login-form__body .login-form__item--center {
    justify-content: center;
    margin-bottom: 0;
}

.login-form .login-form__body .login-form__item .login-form__field-description {
    padding-right: 2rem;
    width: 20%;
    max-width: 20%;
}

    .login-form .login-form__body .login-form__item .login-form__field-input {
        flex: 0 0 80%;
        max-width: 75%;
        padding-bottom: 5px;
        height: auto !important;
        margin-top: 15px;
    }

.password-checkbox{
    position: absolute;
    right: 0;
}

.password-checkbox img {
    width: 1rem;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.password-checkbox-checked img{
    width: 1rem;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/authentication/login/login-form/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,cAAc;AAClB;;IAEI;QACI,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;AAEJ;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,2DAAkE;AACtE","sourcesContent":[".login-form {\r\n    width: 30%;\r\n    margin: auto;\r\n}\r\n\r\n.login-form .login-form__body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 4rem;\r\n}\r\n\r\n.login-form .login-form__body .login-form__item {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.login-form .login-form__body .login-form__item--center {\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.login-form .login-form__body .login-form__item .login-form__field-description {\r\n    padding-right: 2rem;\r\n    width: 20%;\r\n    max-width: 20%;\r\n}\r\n\r\n    .login-form .login-form__body .login-form__item .login-form__field-input {\r\n        flex: 0 0 80%;\r\n        max-width: 75%;\r\n        padding-bottom: 5px;\r\n        height: auto !important;\r\n        margin-top: 15px;\r\n    }\r\n\r\n.password-checkbox{\r\n    position: absolute;\r\n    right: 0;\r\n}\r\n\r\n.password-checkbox img {\r\n    width: 1rem;\r\n    content: url(\"./../../../shared/images/opened_eye.svg\");\r\n}\r\n\r\n.password-checkbox-checked img{\r\n    width: 1rem;\r\n    content: url(\"./../../../shared/images/closed_eye.svg\") !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
